import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

// Endpoints that must go out unauthenticated even when a token happens to be
// in localStorage. Password reset is reached by someone who cannot sign in —
// often on a machine with a stale session from a different account — and
// attaching that session's token would make the request read as if it came
// from the wrong person.
const ANONYMOUS_PATHS = ['/auth/login', '/auth/password-reset'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthService).getAccessTokenSnapshot();
  if (!token || ANONYMOUS_PATHS.some(p => req.url.includes(p))) return next(req);
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
